/*
 * types/services/dr2am.tasks.preferences.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPreference} from './PbPreference';

/**
 * The ServiceCreatePreferenceRequest model module.
 * @module model/ServiceCreatePreferenceRequest
 * @version version not set
 */
export class ServiceCreatePreferenceRequest {
  /**
   * Constructs a new <code>ServiceCreatePreferenceRequest</code>.
   * @alias module:model/ServiceCreatePreferenceRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceCreatePreferenceRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceCreatePreferenceRequest} obj Optional instance to populate.
   * @return {module:model/ServiceCreatePreferenceRequest} The populated <code>ServiceCreatePreferenceRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceCreatePreferenceRequest();
      if (data.hasOwnProperty('preference'))
        obj.preference = PbPreference.constructFromObject(data['preference']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbPreference} preference
 */
ServiceCreatePreferenceRequest.prototype.preference = undefined;


